import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { InnerHero } from '@/components/sections'
import { Prefooter, Footer } from '@/components/layout'
import { LocalizedLink } from '@/components/LocalizedLink'

const storesItalia = [
  { city: 'Napoli', address: 'Via dei Mille, 91 Napoli', note: 'Nashi Store Napoli, il nostro nuovo concept store', image: '/images/stores/napoli.jpg' },
  { city: 'Milano (Via Dante)', address: 'Via Dante 3, 20123, Milano (MI)', tel: '0272 001028', note: 'primo concept store creato da Nashi Argan nel 2014', image: '/images/stores/milano-dante.jpg' },
  { city: 'Milano (Merlata Bloom)', address: 'CC. Merlata Bloom - Via Daimler 61, 20151, Milano (MI)', tel: '0249 422014', image: '/images/stores/milano-merlata.jpg' },
  { city: 'Arese', address: 'IL CENTRO - Via Giuseppe Eugenio Luraghi 11, 20020, Arese (MI)', tel: '0235 999867', note: 'diciottesimo concept store', image: '/images/stores/arese.jpg' },
  { city: 'Grugliasco TO', address: 'V. Crea, 10, 10095 Grugliasco TO', tel: '011 019 6454', image: '/images/stores/milano-grugliasco.jpg' },
  { city: 'Verona', address: 'Corso Porta Borsari, 8 Verona', tel: '045 237 5199', image: '/images/stores/verona.jpg' },
  { city: 'Busto Arsizio', address: 'Via Milano, 4, 21052 Busto Arsizio VA', tel: '0331 108 4881', image: '/images/stores/busto-arsizio.jpg' },
  { city: 'Trento', address: 'Via Oriola 11, 38122 Trento', tel: '0461 141 2818', note: 'ventinovesimo concept store', image: '/images/stores/trento.jpg' },
  { city: 'Assago', address: 'CC. Milanofiori - Viale Milanofiori, 20057, Assago (MI)', tel: '0280 827353', note: 'sedicesimo concept store', image: '/images/stores/assago.jpg' },
  { city: 'Como', address: 'Via Bernardino Luini 32, 22100, Como (CO)', tel: '0314 975460', note: 'dodicesimo concept store', image: '/images/stores/como.jpg' },
  { city: 'Bergamo (Oriocenter)', address: 'Oriocenter - Via Portico 71, 24050, Orio al Serio (BG)', tel: '0355 31686', note: 'terzo concept store, aperto nel 2015', image: '/images/stores/bergamo.jpg' },
  { city: 'Varese', address: 'Corso Giacomo Matteotti 45, 21100, Varese (VA)', tel: '0332 1433367', note: 'ventisettesimo concept Store', image: '/images/stores/varese.jpg' },
  { city: 'Modena', address: 'Via Emilia Centro 136, 41121, Modena (MO)', tel: '0594 723221', note: '32º concept store', image: '/images/stores/modena.jpg' },
  { city: 'Bolzano', address: 'Via dei Portici 71, 39100, Bolzano (BZ)', tel: '0471 1532099', note: 'trentunesimo concept store', image: '/images/stores/bolzano.jpg' },
  { city: 'Roma (Porta di Roma)', address: 'Via Alberto Lionello 201, 00139, Roma (RM)', tel: '0669 367132', note: 'ventiseiesimo concept store', image: '/images/stores/roma-porta-di-roma.jpg' },
  { city: 'Roma (Eur)', address: "Viale dell'Oceano Pacifico 83, 00144, Roma (RM)", tel: '0645 753850', note: 'quinto concept store aperto nel 2016', image: '/images/stores/roma-eur.jpg' },
  { city: 'Roma (Frattina)', address: 'Via Frattina 85, 00187, Roma (RM)', tel: '0667 92910', note: 'settimo concept store aperto nel 2017', image: '/images/stores/roma-frattina.jpg' },
  { city: 'Roma (Maximo)', address: 'Via Laurentina 865, 00143, Roma (RM)', tel: '0690 236829', note: 'decimo concept store aperto nel 2020', image: '/images/stores/roma-maximo.jpg' },
  { city: 'Roma (Cola di Rienzo)', address: 'Via Cola di Rienzo, 185, 00192 Roma RM', tel: '06 6928 2366', image: '/images/stores/roma-cola.jpg' },
  { city: 'Roma (Termini)', address: 'Piazza dei Cinquecento 1, 00185, Roma (RM)', tel: '0645 777560', note: 'nono concept store aperto nel 2020', image: '/images/stores/roma-termini.jpg' },
  { city: 'Torino', address: 'Via Lagrange 11, 10123, Torino (TO)', tel: '0115 623389', note: 'sesto concept store in Italia', image: '/images/stores/torino.jpg' },
  { city: 'Treviso', address: 'Via Calmaggiore 15/17, 31100, Treviso (TV)', tel: '0422 1584631', note: 'tredicesimo concept store aperto nel 2022', image: '/images/stores/treviso.jpg' },
  { city: 'Venezia (Nave de Vero)', address: 'CC Nave de Vero - Via Pietro Arduino 20, 30175, Venezia (VE)', tel: '0412 439187', image: '/images/stores/venezia.jpg' },
  { city: 'Vicenza', address: 'Corso Andrea Palladio 73, 36100, Vicenza (VI)', tel: '0444 1261438', image: '/images/stores/vicenza.jpeg' },
  { city: 'Genova', address: 'Via XX Settembre 199, 16121, Genova (GE)', tel: '0100 999780', note: 'undicesimo concept store', image: '/images/stores/genova.jpg' },
  { city: 'Firenze', address: 'Via dei Lamberti 1, 50123, Firenze (FI)', tel: '0552 396174', note: 'quarto concept store, aperto nel 2016', image: '/images/stores/firenze.jpg' },
  { city: 'Forte dei Marmi', address: 'Via Mazzini 8/A, 55042, Forte dei Marmi (LU)', tel: '0584 1536019', image: '/images/stores/forte-marmi.jpg' },
  { city: 'Palermo', address: 'Via Ruggiero Settimo 77, 90139, Palermo (PA)', tel: '0272 001028', image: '/images/stores/palermo.jpg' },
  { city: 'Parma', address: 'Strada della Repubblica 24, 43121, Parma (PR)', tel: '0521 207076', note: 'secondo concept store, aperto nel 2015', image: '/images/stores/parma.jpg' },
  { city: 'Catania', address: 'Via Etnea 121, 95131, Catania (CT)', tel: '0950 921483', note: 'ventiquattresimo concept Store', image: '/images/stores/catania.jpg' },
  { city: 'Torre Annunziata (Maximall Pompeii)', address: 'Via Plinio 56 - MaxiMall Pompeii, 80058, Torre Annunziata (NA)', tel: '0811 7678311', image: '/images/stores/torre-annunziata.jpg' },
  { city: 'Padova', address: 'Via Roma 52, 35122, Padova (PD)', tel: '0492 141763', note: 'ventitreesimo concept store', image: '/images/stores/padova.jpg' },
  { city: 'Bologna', address: "Via d'Azeglio 10C, 40124, Bologna (BO)", tel: '0510 224587', note: 'ottavo concept store, aperto nel Settembre del 2019', image: '/images/stores/bologna.jpg' },
]

const storesFrancia = [
  { city: 'Parigi (Les 4 Temps)', address: '15 Parv. de la Défense - Puteaux', tel: '+33140260171', image: '/images/stores/parigi-4temps.jpeg' },
  { city: 'Parigi (Rue Saint-Honoré)', address: '193 Rue Saint-Honoré, Parigi, Francia', tel: '+33 1 40 26 01 71', image: '/images/stores/parigi-rue-saint-honore.png' },
  { city: 'Parigi (Rue Montmartre)', address: '65 Rue Montmartre, 75002, Paris (FR)', note: 'primo concept store in Francia', image: '/images/stores/parigi-montmartre.jpeg' },
]

function StoreCard({ store, index, region }: { store: typeof storesItalia[0]; index: number; region: string }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.8, delay: (index % 3) * 0.08 }}
      className="group flex flex-col"
    >
      <div className="flex items-baseline justify-between mb-5">
        <span className="font-display italic text-argan-deep tabular-nums text-2xl">
          {String(index + 1).padStart(2, '0')}.
        </span>
        <span className="text-[10px] uppercase tracking-[0.28em] text-bruno-muted group-hover:text-argan-deep transition-colors">
          {region}
        </span>
      </div>

      <div className="relative aspect-[16/10] bg-cream border border-bruno/10 mb-5 overflow-hidden">
        {store.image ? (
          <img
            src={store.image}
            alt={store.city}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
        ) : (
          <>
            <div
              aria-hidden="true"
              className="absolute inset-0 bg-[radial-gradient(circle_at_30%_30%,rgba(207,169,128,0.18),transparent_60%)]"
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <span
                className="font-display italic text-argan/30"
                style={{ fontSize: 'clamp(3rem, 6vw, 5rem)' }}
              >
                n.
              </span>
            </div>
          </>
        )}
      </div>

      <h3
        className="font-display text-bruno group-hover:text-argan-deep transition-colors"
        style={{
          fontSize: 'clamp(1.125rem, 1.5vw, 1.375rem)',
          lineHeight: 1.2,
          letterSpacing: '-0.005em',
        }}
      >
        {store.city}
      </h3>
      <p className="mt-3 text-bruno-soft text-[14px] leading-relaxed">
        {store.address}
      </p>
      {store.tel && (
        <p className="mt-1 text-bruno-soft text-[14px]">
          Tel: {store.tel}
        </p>
      )}
      {store.note && (
        <p className="mt-3 text-xs text-argan-deep italic">
          {store.note}
        </p>
      )}
    </motion.article>
  )
}

export function NashiStorePage() {
  const { t } = useTranslation('common')

  return (
    <main>
      <InnerHero
        eyebrow={t('nashiStore.heroEyebrow')}
        title={t('nashiStore.heroTitle')}
        titleItalic={t('nashiStore.heroTitleItalic')}
        body={t('nashiStore.heroBody')}
        breadcrumbs={[
          { label: t('nav.home'), href: '/it' },
          { label: t('nashiStore.breadcrumb') },
        ]}
      />

      {/* Philosophy */}
      <section className="bg-cream py-20 md:py-28 overflow-hidden">
        <div className="nashi-container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1 }}
            className="max-w-3xl"
          >
            <span className="nashi-eyebrow">{t('nashiStore.philosophyEyebrow')}</span>
            <h2
              className="mt-6 font-display text-bruno"
              style={{
                fontSize: 'clamp(1.875rem, 3vw, 2.75rem)',
                lineHeight: 1.05,
                letterSpacing: '-0.015em',
              }}
            >
              <span className="block">{t('nashiStore.philosophyTitle1')}</span>
              <span className="block italic font-light text-argan-deep">{t('nashiStore.philosophyTitle2')}</span>
            </h2>
            <p className="mt-6 text-bruno-soft leading-relaxed max-w-md">
              {t('nashiStore.philosophyBody')}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Italia */}
      <section className="bg-cream-soft py-20 md:py-28">
        <div className="nashi-container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9 }}
          >
            <span className="nashi-eyebrow">{t('nashiStore.italyEyebrow')}</span>
            <h2
              className="mt-4 font-display text-bruno"
              style={{
                fontSize: 'clamp(2rem, 4vw, 3.5rem)',
                lineHeight: 1.05,
                letterSpacing: '-0.015em',
              }}
            >
              <span className="italic font-light text-argan-deep">{t('nashiStore.italyTitle1')}</span>
              <span className="block">{t('nashiStore.italyTitle2')}</span>
            </h2>
          </motion.div>

          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 md:gap-x-10 gap-y-12 md:gap-y-16">
            {storesItalia.map((store, i) => (
              <StoreCard key={store.city} store={store} index={i} region={t('nashiStore.regionItaly')} />
            ))}
          </div>
        </div>
      </section>

      {/* Francia */}
      <section className="bg-cream py-20 md:py-28">
        <div className="nashi-container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9 }}
          >
            <span className="nashi-eyebrow">{t('nashiStore.franceEyebrow')}</span>
            <h2
              className="mt-4 font-display text-bruno"
              style={{
                fontSize: 'clamp(2rem, 4vw, 3.5rem)',
                lineHeight: 1.05,
                letterSpacing: '-0.015em',
              }}
            >
              <span className="italic font-light text-argan-deep">{t('nashiStore.franceTitle1')}</span>
              <span className="block">{t('nashiStore.franceTitle2')}</span>
            </h2>
          </motion.div>

          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 md:gap-x-10 gap-y-12 md:gap-y-16">
            {storesFrancia.map((store, i) => (
              <StoreCard key={store.city} store={store} index={i} region={t('nashiStore.regionFrance')} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Store Locator */}
      <section className="bg-cream-soft py-20 md:py-28">
        <div className="nashi-container text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9 }}
          >
            <span className="nashi-eyebrow">{t('nashiStore.ctaEyebrow')}</span>
            <h2
              className="mt-6 font-display text-bruno mx-auto max-w-2xl"
              style={{
                fontSize: 'clamp(2rem, 4vw, 3.5rem)',
                lineHeight: 1.05,
                letterSpacing: '-0.015em',
              }}
            >
              <span className="block">{t('nashiStore.ctaTitle1')}</span>
              <span className="block italic font-light text-argan-deep">{t('nashiStore.ctaTitle2')}</span>
            </h2>
            <LocalizedLink
              to="storeLocator"
              className="mt-10 inline-flex items-center gap-3 bg-bruno text-cream font-medium uppercase tracking-[0.28em] text-[11px] px-10 py-4 hover:bg-argan-deep transition-colors group"
            >
              {t('utility.storeLocator')}
              <ArrowRight
                className="h-3.5 w-3.5 transition-transform duration-500 group-hover:translate-x-1"
                strokeWidth={1.75}
              />
            </LocalizedLink>
          </motion.div>
        </div>
      </section>

      <Prefooter />
      <Footer />
    </main>
  )
}
